import React, { useState } from 'react';
import '../../css/FAQs.css'; // Import the CSS file

const FAQIAATs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What’s the Iowa Algebra Aptitude Test (IAAT)?",
      answer: "The IAAT is a test designed to assess your algebra skills, challenging you with problems that help evaluate your readiness for advanced math courses. It’s a great way to discover your strengths and areas for growth in algebra."
    },
    {
      question: "Why Should I Take the IAAT?",
      answer: "Taking the IAAT helps you identify your current math skills and gives you a chance to prepare for more challenging algebra concepts. It’s also a stepping stone for advanced math courses in school!"
    },
    {
      question: "How Can I Prepare for the IAAT?",
      answer: "Practice is key! Use prep materials, sample questions, and interactive tools to help you understand key algebra concepts. The more you practice, the more confident you'll feel when test day arrives!"
    },
    {
      question: "When is the Best Time to Take the IAAT?",
      answer: "The ideal time to take the IAAT is when you’ve mastered the basics of algebra and feel ready to challenge yourself. Early preparation gives you an advantage in scoring well!"
    },
    {
      question: "What Type of Questions Will I Encounter on the IAAT?",
      answer: "Expect multiple-choice questions that assess your understanding of algebraic concepts, equations, and problem-solving skills. It’s designed to evaluate your ability to apply what you’ve learned!"
    }
  ];

  return (
    <div>
      <h1 className="iaat-title">
        Frequently Asked Questions
      </h1>
      <div className="faq-container">

        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div
              className="faq-question"
              onClick={() => toggleQuestion(index)}
              style={{ cursor: 'pointer' }}
            >
              {faq.question}
              <span className={`faq-toggle-icon ${openIndex === index ? 'open' : ''}`}>
                {openIndex === index ? '-' : '+'}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQIAATs;
